/**
 * THE GATE — there is no web login. This console is entered exclusively through the
 * mobile companion app's "Deploy to Production" hand-off (a one-time, 60-second
 * auto-login link). Design & preview live on the phone; build, sign and download here.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/store';

export function LoginPage(): JSX.Element {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to="/apps" replace />;

  return (
    <div className="gate-screen">
      <div className="gate-box">
        <span className="gate-eyebrow">Deployment console</span>
        <h1 className="gate-title">
          Designed on your phone.
          <br />
          Deployed here.
        </h1>
        <p className="gate-sub">
          This console signs you in straight from the <strong>App Builder Studio</strong> app —
          no passwords, no forms.
        </p>

        <div className="gate-panel">
          <div className="gate-step">
            <span className="gate-step-num">1</span>
            <div>
              <b>Open App Builder Studio on your phone</b>
              <span>Your workspace — pages, theme, icons and previews — lives in the app.</span>
            </div>
          </div>
          <div className="gate-step">
            <span className="gate-step-num">2</span>
            <div>
              <b>Finish your Project Checklist</b>
              <span>Pages, theme &amp; icons, notifications — the app walks you through it.</span>
            </div>
          </div>
          <div className="gate-step">
            <span className="gate-step-num">3</span>
            <div>
              <b>Tap “Deploy to Production”</b>
              <span>
                Your browser opens this console already signed in — ready to build, sign and
                download your store-ready package.
              </span>
              <div className="gate-deploy">⚙️ Run on Desktop Web</div>
            </div>
          </div>
        </div>

        <p className="gate-note">
          Sign-in links are <code>single-use</code> and expire after <code>60 seconds</code>.
          <br />
          Landed here by accident? Just tap Deploy again in the app.
        </p>
      </div>
    </div>
  );
}
